import React, { useEffect } from "react";
import { transformTranslateFromValues } from "lib/helpers";
import { handleSuccessMessages } from "store/auth";
import { Field, Form, Formik } from "formik";
import { CkEditor, Loading } from "components/form";
import { useSetting } from "store/settings";
import { TextField } from "components/form";
import { TextArea } from "components/form";

const Seo = (props) => {
  const {
    dispatch,
    getSetting,
    submitSetting,
    seo,
    loading,
  } = useSetting();
  const key = "seo";

  useEffect(() => {
    dispatch(getSetting(key));
  }, []);

  if (loading) {
    return (
      <div className="box p-5 flex justify-center">
        <Loading />
      </div>
    );
  }
  return (
    <>
      <Formik
        initialValues={seo || {}}
        onSubmit={async (values, { setSubmitting }) => {
          await dispatch(
            submitSetting({ value: values, key }, () =>
              handleSuccessMessages("ویرایش اطلاعات انجام شد")
            )
          );
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty }) => (
          <Form>
            <div className="box rounded p-3">
              <h3>تنظیمات سئو</h3>
              <hr className="my-2" />
              <div className="">
                <div className="intro-x grid grid-cols-2 gap-4">
                  <Field
                    placeholder="عنوان سایت"
                    label="عنوان سایت :"
                    name="site_title"
                    component={TextField}
                  />

                  <Field
                    placeholder="(en) عنوان سایت"
                    label="عنوان سایت (en):"
                    name="en_site_title"
                    component={TextField}
                  />

                  <Field
                    label="توضیحات سئو(max 160 characters):"
                    name="seo_desc"
                    component={TextArea}
                  />

                  <Field
                    label="توضیحات انگلیسی سئو(max 160 characters):"
                    name="en_seo_desc"
                    component={TextArea}
                  />
                   <Field
                    label="کلمات کلیدی سئو(مانند:سریال,اکشن):"
                    name="seo_keywords"
                    component={TextArea}
                  />

                    <Field
                    label="کلمات کلیدی انگلیسی سئو(مانند:serie,action):"
                    name="en_seo_keywords"
                    component={TextArea}
                  />
                
                  <button
                    className="mt-4 btn btn-primary w-20"
                    type="submit"
                    disabled={!!(isSubmitting || !dirty)}
                  >
                    {isSubmitting ? <Loading /> : "ذخیره"}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default Seo;
